import React, { PureComponent, ReactNode } from 'react'
import { connectRedux } from '../../../helpers/connectRedux'
import { IStoreState } from '../../../store/states'
import { Page } from '../../../components'
import LanguageSelector from '../../../containers/LanguageSelector'
import { SignUpStep3Form, SIGN_UP_STEP_TITLES } from '../../../containers/SignUpForms'
import { images } from '../../../images'
import { LiteralsService } from '../../../services'
import StyledArticle from '../styles'
import { appsLogosSelected, appsStyleSelected } from '../../../helpers/app'

// The terms and the registration itself live in SignUpStep3Form, shared with the guest prompt.
interface IProps {
  language: string
}

class SignUpStep3 extends PureComponent<IProps> {
  public render(): ReactNode {
    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <div className="language-selector">
            <LanguageSelector />
          </div>
          <form onSubmit={ e => e.preventDefault() }>
            <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
            <header>
              <img  className={ appsLogosSelected?.classRounded }
                    src={ appsLogosSelected?.logoRounded }
                    alt={ appsLogosSelected?.alt } />
              <h2>{ LiteralsService.get(SIGN_UP_STEP_TITLES[2], true) }</h2>
            </header>
            <SignUpStep3Form />
          </form>
        </StyledArticle>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }
}

// Redraws the literals when the language selector changes the language.
const mapStateToProps = ({ configuration }: IStoreState) => ({
  language: configuration.language
})

export default connectRedux(mapStateToProps, SignUpStep3)
